/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import {View} from 'react-native';
import {DateToddmmyyyyFormat} from '../../../../data/factory';
import {InputAutocompletion} from '../../../components/Inputs/InputAutocompletion';
import {InputDatePicker} from '../../../components/Inputs/InputDatePicker';
import {InputField} from '../../../components/Inputs/InputField';
import {InputImage} from '../../../components/Inputs/InputImage';
import { Validation } from '../../../../common/utils/validationSinistreAM';
import SecondaryButton from '../../../components/Button/SecondaryButton';
import { TitleLabels } from '../../../../data/constants/Sinistres/autoMoto';
import { useForm } from '../../../../hooks/Sinistres/useFormAM';

export const Form = (props: any) => {
  const {
    data,
    listAgence,
    onCancelForm,
    onSubmitForm,
    listContrat,
    isRedirection,
    listContratSvg,
  } = props;
  const {handleChange, handleSubmit, values, errors, showErrors, dto} = useForm(
    data,
    Validation,
    handleCancel,
    handleSave,
    listAgence,
    listContratSvg,
  );

  function handleCancel() {
    onCancelForm();
  }

  function handleSave() {
    if (dto.data.dateAccident instanceof Date) {
      dto.data.dateAccident = DateToddmmyyyyFormat(dto.data.dateAccident);
    }
    onSubmitForm(dto.data);
  }

  return (
    <View>
      {/** form inputs */}
      <View>
        <InputAutocompletion
          label={TitleLabels.infos.numeroContrat}
          required
          data={listContrat}
          name="numeroContrat"
          value={values.numeroContrat ? values.numeroContrat : ''}
          onChange={handleChange}
          error={errors.numeroContrat}
          showError={showErrors.numeroContrat}
          isEditable={!isRedirection}
        />
        <InputField
          label={TitleLabels.infos.immatriculation}
          required
          value={values.immatriculation}
          name="immatriculation"
          type="alphanumeric"
          onChange={handleChange}
          error={errors.immatriculation}
          showError={showErrors.immatriculation}
          maxLength={10}
          isEditable={true}
        />
        <InputDatePicker
          label={TitleLabels.infos.dateAccident}
          required
          value={values.dateAccident}
          name="dateAccident"
          onChange={handleChange}
          error={errors.dateAccident}
          showError={showErrors.dateAccident}
          todayDate={true}
        />
        <InputAutocompletion
          label={TitleLabels.infos.agence}
          required
          data={listAgence}
          name="agence"
          value={values.agence}
          onChange={handleChange}
          error={errors.agence}
          showError={showErrors.agence}
          isEditable={false}
        />
        <InputField
          label={TitleLabels.infos.telephone}
          required
          name="telephone"
          type="telephone"
          value={values.telephone}
          onChange={handleChange}
          error={errors.telephone}
          showError={showErrors.telephone}
          isEditable={false}
        />
        <InputField
          label={TitleLabels.infos.circonstanceAccident}
          required
          type="textArea"
          value={values.circonstanceAccident}
          name="circonstanceAccident"
          onChange={handleChange}
          error={errors.circonstanceAccident}
          showError={showErrors.circonstanceAccident}
          maxLength={1000}
          isEditable={true}
        />
        <InputImage
          label={TitleLabels.infos.photo}
          required
          value={values.photo}
          name="photo"
          onChange={handleChange}
          error={errors.photo}
          showError={showErrors.photo}
          maxLength={5}
        />
        <InputImage
          label={TitleLabels.infos.pieceJointeAgence}
          value={values.pieceJointeAgence}
          name="pieceJointeAgence"
          onChange={handleChange}
          error={errors.pieceJointeAgence}
          showError={showErrors.pieceJointeAgence}
          maxLength={5}
          isFile={true}
        />
      </View>
      {/** Submit buttons */}
      <View>
        <SecondaryButton
          cancelAction={handleCancel}
          submitAction={handleSubmit}
          cancelTitle="Annuler"
          submitTitle="Demander prise en compte"
        />
      </View>
    </View>
  );
};
